import { Component, HostListener, OnDestroy, OnInit, EventEmitter, Output, ViewChild, TemplateRef, Renderer2, ComponentFactoryResolver, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { QualService } from 'src/app/qual/service/qual.service';
import { InsightsService } from './service/insights.service';
import { VideoModalComponent } from './video-modal/videomodal';
import { VideoModalNewComponent } from './video-modal-new/videomodal';
import { DeletePopComponent } from './voc-delete/delete-pop';
import { VocIntroComponent } from './voc-intro-screen/voc-intro';
import { InsightApiService } from './service/insight-api.service';
import { Item, ReportService } from 'src/app/repository/service/report.service';
import { NotifierService } from 'angular-notifier';
import { mixinHasStickyInput } from '@angular/cdk/table';
import { TrackerService } from 'src/app/repository/service/tracker.service';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
// import { truncate } from 'fs';
import { ActivatedRoute, Router } from '@angular/router';
import { VocIntroPngComponent } from './voc-intro-png/voc-intro-png.component';
import { SidePanelService } from '../services/side-pannel/side-pannel.service';

@Component({
  selector: 'app-insights',
  templateUrl: './insights.component.html',
  styleUrls: ['./insights.component.scss']
})
export class InsightsComponent implements OnInit, OnDestroy {
  @Output() vocEvent = new EventEmitter();
  public voc_customer_show:boolean = true;
  public voc_club_show:boolean = false;
  public markNewVocSwitch: boolean = true;
  public commentNotifyPopup:boolean=false;
  public isEmailAllNotifyShow:boolean = false;
  public isDisableVocClub:boolean = false;
  public dummyCommentArr = ['xyz@crownit','Miraj@crownit','Faiz@crownit','Gaurav@crownit','xyz@crownit','Miraj@crownit','Faiz@crownit','Gaurav@crownit'];
  public vocdescTitle: number = 1;
  public CommentNotifyDupilcateArr:any;
  public commentForm = new FormGroup({
    comment: new FormControl('', [Validators.required]),
    visibility: new FormControl('everyone')
  });
  public editClubUUID = null;
  public clubingVocArray:any = [];
  public isQual:boolean = false;
  public RealcurrenTime:number;
  public vocReff;
  public isDisableVocSave:boolean = false;
  public isVocClubHasIntroScreen:boolean = false;
  public accessRoles:any;
  
  
  public fileVocListShow:any = [];
  constructor(public QService: QualService, 
    public iService: InsightsService, 
    private Dialoge: MatDialog,
    public apiService:InsightApiService,
    public reportService:ReportService,
    public notifier: NotifierService,
    public trackerService:TrackerService,
    private router: Router,
    public sidePanelService: SidePanelService,
    private readonly renderer: Renderer2,
    private fResolver: ComponentFactoryResolver,
    private viewContainer: ViewContainerRef,
    public route: ActivatedRoute,
    private cdr: ChangeDetectorRef
    ) {

  }

  ngOnInit() {
    if(this.iService.isVOC) {
      this.iService.checkMarkVOCAccess();
      if(!this.iService.isVocCompCallFromStudyLevel){
        this.reportService.getVocList();
      }
    }
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    let time = new Date();
    let arr = time.toLocaleTimeString().split(":");
    this.RealcurrenTime = +arr[0]*3600 + +arr[1]*60 + +arr[2].split(" ")[0]; 
    // this.iService.getVocClubs(this.route.snapshot.params['uuid']);
    // if (this.router.url.includes('qual')) {
    //  this.isQual = true;     
    // }else{
    //   this.isQual = false;     
    // }
  }

  ngOnDestroy() {
    this.iService.close();
    this.iService.insightList = [];
    this.iService.uuid = '';
    this.iService.insightType = '';
    this.iService.insightName = '';
    this.iService.visibility = 'everyone';
    this.editClubUUID = null;
    this.isDisableVocSave = false;
  }

  @HostListener('document:click', ['$event'])
  onClick(ev:MouseEvent){
    if(this.iService.isVOC){
      let classListArr = Array.from(ev.target['classList']);
      if(this.iService.VOCList && this.iService.VOCList.length>0){
        if(classListArr && !classListArr.includes('voc_hamberger')){
          this.iService.VOCList.forEach((itm,index)=>{
            this.iService.VOCList[index].isHambergerClicked = false;
          })
        }
      }
      if(this.iService.VOCClubList && this.iService.VOCClubList.length>0){
        if(classListArr && !classListArr.includes('voc_club_list_hamberger')){
          this.iService.VOCClubList.forEach((itm,index)=>{
            this.iService.VOCClubList[index].isHambergerClicked = false;
          })
        }
      }
      if(this.iService.VOCsToBeClub && this.iService.VOCsToBeClub.vocs && this.iService.VOCsToBeClub.vocs.length>0){
        if(classListArr && !classListArr.includes('voc_club_edit_hamberger')){
          this.iService.VOCsToBeClub.vocs.forEach((itm,index)=>{
            this.iService.VOCsToBeClub.vocs[index].isHambergerClicked = false;
          })
        }
      }
      if(this.iService.vocStudyLevelArray && this.iService.vocStudyLevelArray.length>0){
        if(classListArr && !classListArr.includes('voc_hamberger_study_level')){
          this.iService.vocStudyLevelArray.forEach((vocs,pIndex) => {
            vocs['vocs'].forEach((voc,mIndex) => {
              this.iService.vocStudyLevelArray[pIndex]['vocs'][mIndex].isHambergerClicked = false;
            })
          })
        }
      }

    }
  }

 
  
  onSubmit(){
    if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      if(this.commentForm.value['visibility'] == 'everyone' && this.iService.commentNotifEmailyArr.length > 0 && this.commentForm.value['comment'] != ""){
        this.commentNotifyPopup = !this.commentNotifyPopup;
      }else{
        this.commentNotifyPopup = false;
        let body = {
          "uuid": this.iService.uuid,
          "type": this.iService.insightType,
          "comment": this.commentForm.value['comment'],
          "visibility": this.commentForm.value['visibility']
        };
        if (body.uuid != '' && body.type != '' && body.comment != '') {
          this.iService.addInsight(body);
          // this.commentForm.reset();
          this.commentForm.patchValue({
            comment: null,
            visibility: 'everyone'
          });
        }
      }
    }
  }
  CommentNotify = (ind:number) =>
  {
    if(ind === 0)
    {
       let body = {
       "uuid": this.iService.uuid,
        "type": this.iService.insightType,
        "comment": this.commentForm.value['comment'],
        "visibility": this.commentForm.value['visibility'],
        "users":[],
      };
      if (body.uuid != '' && body.type != '' && body.comment != '') {
        this.iService.addInsight(body);
        // this.commentForm.reset();
        this.commentForm.patchValue({
          comment: null,
          visibility: 'everyone'
        });
      }
      this.commentNotifyPopup = false;
      this.isEmailAllNotifyShow = false; 
    }
    else
    {
      let users_filter = [];
      for(let Item of this.iService.commentNotifEmailyArr)
      {
        if(Item.checked)
        {
          users_filter.push(Item.value);
        }
      }
      let body = {
        "uuid": this.iService.uuid,
         "type": this.iService.insightType,
         "comment": this.commentForm.value['comment'],
         "visibility": this.commentForm.value['visibility'],
         "users":users_filter
       };
       if (body.uuid != '' && body.type != '' && body.comment != '') {
         this.iService.addInsight(body);
         // this.commentForm.reset();
         this.commentForm.patchValue({
           comment: null,
           visibility: 'everyone'
         });
       }
       this.commentNotifyPopup = false;
       this.isEmailAllNotifyShow = false; 
       this.iService.commentNotifEmailyArr = this.iService.commentNotifEmailyArrCopy;
    }

  }
  DialogeCloseforCommentNotify = () =>
  {
    this.commentNotifyPopup = !this.commentNotifyPopup;
    this.isEmailAllNotifyShow = false;
    this.iService.commentNotifEmailyArr = this.iService.commentNotifEmailyArrCopy
    // console.log('Hiiiiiiiiii',this.iService.commentNotifEmailyArr);
  }
  
  editCommentVisibility(e,id,uuid,type){
    let obj = {"uuid":uuid,"visibility":e.target.value,"comment_id":id,"type":type};
    this.iService.updateCommentVisibility(obj);
  }

  playMedia(index:number,isNewVOC){
    // this.openVideoModal(index,'voc');
    this.openVideoModal(index,0,0,'voc',isNewVOC);
  }

  playClubMedia(index:number,isNewVOC) {
    // this.openVideoModal(index,'club');
    this.openVideoModal(index,0,0,'club',isNewVOC);
  }

  // openVideoModal = (index:number,type:string) =>
  // {
  //   this.vocEvent.emit('pause');
  //   this.trackerService.interval = 0;
  //   let Width = '900px';
  //   let Height = '585px';
  //   const dialogRef = this.Dialoge.open(VideoModalComponent,{
  //     width:Width,
  //     height:Height,
  //     data:{
  //       vocs:type=='voc' ? this.iService.VOCList : this.iService.VOCClubList,
  //       index:index,
  //       type:type
  //     },
  //     disableClose: true
  //   });
  //   dialogRef.afterClosed().subscribe(result =>{
  //     this.vocEvent.emit('play');
  //   })
  //   this.openVideoModal(index,0,0,'voc');
  // }
  playMediaForStudy = (index:number,ind:number,isNewVOC) =>{
    this.openVideoModal(index,1,ind,'voc',isNewVOC);
  }

  openVideoModal = (index:number,flag:number,ind,type:string,isNewVOC) =>
  {
    this.vocEvent.emit('pause');
    this.trackerService.interval = 0;
    let Width = '900px';
    let Height = '585px';
    let vocs = [];
    let _type = '';
    if(type == 'club'){
      vocs = this.iService.VOCClubList;
      _type = 'club';
    }
    else{
      _type = 'voc';
      if(flag === 1){
        vocs = this.iService.vocStudyLevelArray[ind]['vocs'];
      }
      else{
        vocs = this.iService.VOCList;
      }
    }

    let test = {
      vocs:vocs,
      index:index,
      type:_type
    }
    // console.log("is new Voc "+isNewVOC+" and value is ===> ",test)
    if(isNewVOC){
      const dialogRef = this.Dialoge.open(VideoModalNewComponent,{
        width:Width,
        height:Height,
        data:{
          vocs:vocs,
          index:index,
          type:_type
        },
        disableClose: true
      });
    }
    else{
      const dialogRef = this.Dialoge.open(VideoModalComponent,{
        width:Width,
        height:Height,
        data:{
          vocs:vocs,
          index:index,
          type:_type
        },
        disableClose: true
      });
    }
    // dialogRef.afterClosed().subscribe(result =>{
    //   this.vocEvent.emit('play');
    // })
  }

  hoverCard(index){
    this.iService.VOCList[index].isHovered=true;
  }
  unHoverCard(index){
    this.iService.VOCList[index].isHovered=false;
  }
  hoverClubCard(index){
    this.iService.VOCClubList[index].isHovered=true;
  }
  unHoverClubCard(index){
    this.iService.VOCClubList[index].isHovered=false;
  }
  hoverCard1(ind1,index){
    this.iService.vocStudyLevelArray[ind1].vocs[index]['isHovered']=true;
  }
  unHoverCard1(ind1,index){
    this.iService.vocStudyLevelArray[ind1].vocs[index]['isHovered']=false;
  }
  hambergerClick(index,e){
    e.stopPropagation();
    this.iService.VOCList.forEach((item,ind)=>{
      if(ind==index){
        this.iService.VOCList[ind].isHambergerClicked=true;
      }
      else{
        this.iService.VOCList[ind].isHambergerClicked=false;
      }
    });
  }

  hambergerClubListClick(index,e) {
    e.stopPropagation();
    this.iService.VOCClubList.forEach((item,ind)=>{
      if(ind==index){
        this.iService.VOCClubList[ind].isHambergerClicked=true;
      }
      else{
        this.iService.VOCClubList[ind].isHambergerClicked=false;
      }
    });
  }

  hambergerScreenClick(index,e) {
    e.stopPropagation();
    this.iService.VOCsToBeClub.vocs.forEach((item,ind)=>{
      if(ind==index){
        this.iService.VOCsToBeClub.vocs[ind].isHambergerClicked = true;
      }
      else{
        this.iService.VOCsToBeClub.vocs[ind].isHambergerClicked = false;
      }
    });
  }

  VocClip = () => {
    this.markNewVocSwitch = !this.markNewVocSwitch
    this.iService.vocIntroFormtitle = "";
    this.iService.vocIntroFormSubtitle = [{value:""}];
    this.iService.start_time="";
    this.iService.end_time="";
    this.iService.comment="";
    this.iService.isvocadd = true;
    this.iService.isvocEdit = false;
    this.iService.isvocEditFormSubmit = false;
  }

  Validation = (data:any) =>
  {
    if(data.startTime && data.endTime && data.comment)
    {
      let arr = data.startTime.split(':');
      let arr1 = data.endTime.split(':');
      // console.log(arr,arr1,'InVoc');
      if((+arr[0] < 60 && +arr[1] < 60 && +arr[2] < 60) && (+arr1[0] < 60 && +arr1[1] < 60 && +arr1[2] < 60 ))
      {
        let StartTimeDuration = +arr[0]*60*60 + +arr[1]*60 + +arr[2];
        let EndTimeDuration = +arr1[0]*60*60 + +arr1[1]*60 + +arr1[2];
        let Duration = Math.floor(this.iService.video_duration);
        if(!isNaN(Duration)){
          if(StartTimeDuration < Duration && EndTimeDuration <= Duration && StartTimeDuration < EndTimeDuration)
          {
            return 1;
          }
          this.notifier.notify('error','Invalid Time Range');
          return 0;
        }
        this.notifier.notify('info','Processing VOC data, please try again');
        return 0;
      }
      this.notifier.notify('error','Invalid Time Range');
      return 0;
     
    }
    this.notifier.notify('error','Please Fill All Mandatory Fields');
    return 0;
  }
  // onVocAddFormSubmit = () => {
  //   let data = {'startTime':this.iService.start_time,'endTime':this.iService.end_time,comment:this.iService.comment}
  //   if(this.iService.isvocEditFormSubmit)
  //   {
  //     //console.log('hIIII iF');
  //     if((this.Validation(data)))
  //     {
  //       let start_time = data.startTime;
  //       let end_time = data.endTime;
  //       let misc = {}
  //       let preview = {};
  //       if(this.iService.vocIntroFormtitle)
  //       {
  //         preview['title'] = this.iService.vocIntroFormtitle;
  //         misc['preview'] = preview;
          
  //       }
  //       if(this.iService.vocIntroFormSubtitle)
  //       {
  //         // let arr = this.iService.vocIntroFormSubtitle.map((va:any) => va.value);
  //         //   preview['text'] = arr;
  //         //   misc['preview'] = preview;
  //         let arr = this.iService.vocIntroFormSubtitle.map((va:any) => va.value).filter(v => v);
  //         if(arr.length > 0)
  //         {
  //           preview['text'] = arr;
  //           misc['preview'] = preview;
  //         }
  //       }
  //       if(data.comment)
  //       {
  //         misc['comment'] = data.comment;
  //       }
  //       let body = {'start_time':start_time,'end_time':end_time,'uuid':this.iService.current_voc_uuid,'misc':JSON.stringify(misc)};
  //       this.apiService.updateVocClip(body).subscribe((result) =>
  //       {
  //         //console.log(result,'Update Api work fine');
  //         if(result.status === 1)
  //         {
  //           this.reportService.getVocList();
  //           this.notifier.notify('info','Voc Edit in Progress');
  //           this.markNewVocSwitch = true;
  //         }
  //         else
  //         {
  //           this.reportService.getVocList();
  //           this.notifier.notify('error',result.message);
  //           this.markNewVocSwitch = true;
  //         }
          
  //       },(err) =>
  //       {
  //         this.notifier.notify('error','Something Went Wrong');
  //         //console.log(err,console.log('error'));
  //       })
  //       this.iService.isvocadd = true;
  //       this.iService.isvocEdit = false;
  //       this.iService.vocIntroFormtitle = "";
  //       this.iService.vocIntroFormSubtitle = [{value:""}];
  //       this.iService.copyvocIntroFormSubtitle = [];
  //       this.iService.copyvocIntroFormtitle = "";
  //       this.iService.start_time="";
  //       this.iService.end_time="";
  //       this.iService.comment="";
  //       this.markNewVocSwitch = true;
  //       // this.iService.isvocEditFormSubmit = false;
  //     }
  //   }
  //   else
  //   {
  //     if((this.Validation(data)))
  //     {
  //       //console.log('hIIII else');
  //       let start_time = data.startTime;
  //       let end_time = data.endTime;
  //       let misc = {}
  //       let preview = {};
  //       if(this.iService.vocIntroFormtitle)
  //       {
  //         // console.log(misc['preview']['title'] = this.iService.vocIntroFormtitle,'mISC1');
  //         preview['title'] = this.iService.vocIntroFormtitle;
  //         misc['preview'] = preview;
  //       }
  //       if(this.iService.vocIntroFormSubtitle)
  //       {
  //         // console.log(misc['preview']['text'] = this.iService.vocIntroFormtitle,'mISC1');
  //         let arr = this.iService.vocIntroFormSubtitle.map((va:any) => va.value).filter(v => v);
  //         if(arr.length > 0)
  //         {
  //           preview['text'] = arr;
  //           misc['preview'] = preview;
  //         }
  //       }
  //       if(data.comment)
  //       {
  //         misc['comment'] = data.comment;
  //       }
  //       let body = {'start_time':start_time,'end_time':end_time,'uuid':this.iService.current_file_uuid,'misc':JSON.stringify(misc)};
  //       this.apiService.addVocClip(body).subscribe((result) =>
  //       {
  //         //console.log(result,'Delete Api work fine');
  //         if(result.status === 1)
  //         {
  //           this.reportService.getVocList();
  //           this.notifier.notify('info','Voc Creation in Progress');
  //           this.markNewVocSwitch = true;
  //         }
  //         else
  //         {
  //           this.reportService.getVocList();
  //           this.notifier.notify('error',result.message);
  //           this.markNewVocSwitch = true;
  //         }
        
  //       },(err) =>
  //       {
  //         this.notifier.notify('error','Something Went Wrong');
  //         //console.log(err,'erros');
  //       })
  //       this.iService.isvocadd = true;
  //       this.iService.isvocEdit = false;
  //       this.iService.vocIntroFormtitle = "";
  //       this.iService.vocIntroFormSubtitle = [{value:""}];
  //       this.iService.copyvocIntroFormSubtitle = [];
  //       this.iService.copyvocIntroFormtitle = "";
  //       this.iService.start_time="";
  //       this.iService.end_time="";
  //       this.iService.comment="";
  //       this.markNewVocSwitch = true;
  //     }
  //   }
   
  // }

    onVocAddSubmit = () => {
    let data = {'startTime':this.iService.start_time,'endTime':this.iService.end_time,comment:this.iService.comment}
    if(this.iService.isvocEditFormSubmit)
    {
      //console.log('hIIII iF');
      if((this.Validation(data)))
      {
        let start_time = data.startTime;
        let end_time = data.endTime;
        let misc = {}
        let preview = {};
        if(this.iService.vocIntroFormtitle)
        {
          preview['title'] = this.iService.vocIntroFormtitle;
          if (this.iService.vocIntroScreenName && this.iService.vocIntroScreenName != "") {
            preview['image'] = this.iService.vocIntroScreenName;
          }
          misc['preview'] = preview;
        }
        if(this.iService.vocIntroFormSubtitle)
        {
          // let arr = this.iService.vocIntroFormSubtitle.map((va:any) => va.value);
          //   preview['text'] = arr;
          //   misc['preview'] = preview;
          let arr = this.iService.vocIntroFormSubtitle.map((va:any) => va.value).filter(v => v);
          if(arr.length > 0)
          {
            preview['text'] = arr;
            misc['preview'] = preview;
          }
        }
        if(data.comment)
        {
          misc['comment'] = data.comment;
        }
        // let body = new FormData();
        // if (this.iService.vocScreenPng && this.iService.vocScreenPng.length) {
        //   body.append('file', this.iService.vocScreenPng[0], 'voc_screen.png');
        // }
        // body.append('start_time', start_time);
        // body.append('end_time', end_time);
        // body.append('uuid', this.iService.current_voc_uuid);
        // body.append('misc', JSON.stringify(misc));
        // console.log("body is ====> ",body)
        let body = {'start_time':start_time,'end_time':end_time,'uuid':this.iService.current_voc_uuid,'misc':JSON.stringify(misc)};
        this.apiService.updateVocClip(body).subscribe((result) =>
        { 
          //console.log(result,'Update Api work fine');
          if(result.status === 1)
          {
            this.markNewVocSwitch = true;
            this.reportService.getVocList();
            // this.notifier.notify('info','Voc Edit in Progress');
            this.isDisableVocSave = false;
          }
          else
          {
            this.markNewVocSwitch = true;
            this.reportService.getVocList();
            this.notifier.notify('error',result.message);
            this.isDisableVocSave = false;
          }
          this.iService.vocScreenPng = [];
        },(err) =>
        {
          this.notifier.notify('error','Something Went Wrong');
          //console.log(err,console.log('error'));
        })
        this.iService.isvocadd = true;
        this.iService.isvocEdit = false;
        this.iService.vocIntroFormtitle = "";
        this.iService.vocIntroScreenName = "";
        this.iService.vocIntroFormSubtitle = [{value:""}];
        this.iService.copyvocIntroFormSubtitle = [];
        this.iService.copyvocIntroFormtitle = "";
        this.iService.start_time="";
        this.iService.end_time="";
        this.iService.comment="";
        this.markNewVocSwitch = true;
        this.isDisableVocSave = false;
        setTimeout(() => {
          this.cdr.detectChanges();  // Ensure Angular picks up the changes
        }, 100);
        // this.iService.isvocEditFormSubmit = false;
      }
    }
    else
    {
      if((this.Validation(data)))
      {
        //console.log('hIIII else');
        let start_time = data.startTime;
        let end_time = data.endTime;
        let misc = {}
        let preview = {};
        if(this.iService.vocIntroFormtitle)
        {
          // console.log(misc['preview']['title'] = this.iService.vocIntroFormtitle,'mISC1');
          preview['title'] = this.iService.vocIntroFormtitle;
          if (this.iService.vocIntroScreenName && this.iService.vocIntroScreenName != "") {
            preview['image'] = this.iService.vocIntroScreenName;
          }
          misc['preview'] = preview;
        }
        if(this.iService.vocIntroFormSubtitle)
        {
          // console.log(misc['preview']['text'] = this.iService.vocIntroFormtitle,'mISC1');
          let arr = this.iService.vocIntroFormSubtitle.map((va:any) => va.value).filter(v => v);
          if(arr.length > 0)
          {
            preview['text'] = arr;
            misc['preview'] = preview;
          }
        }
        if(data.comment)
        {
          misc['comment'] = data.comment;
        }
        // let body = new FormData();
        // if (this.iService.vocScreenPng && this.iService.vocScreenPng.length) {
        //   body.append('file', this.iService.vocScreenPng[0], 'voc_screen.png');
        // }
        // body.append('start_time', start_time);
        // body.append('end_time', end_time);
        // body.append('uuid', this.iService.current_voc_uuid);
        // body.append('misc', JSON.stringify(misc));
        // console.log("body is ====> ",body)
        let body = {'start_time':start_time,'end_time':end_time,'uuid':this.iService.current_file_uuid,'misc':JSON.stringify(misc)};
        // console.log("notifier notify called")
        this.apiService.addVocClip(body).subscribe((result) =>
        {
          //console.log(result,'Delete Api work fine');
          if(result.status === 1)
          {
            this.markNewVocSwitch = true;
            this.reportService.getVocList();
            // this.notifier.notify('info','Voc Creation in Progress');
            // console.log("notifier notify called")
            this.isDisableVocSave = false;
          }
          else
          {
            this.markNewVocSwitch = true;
            this.reportService.getVocList();
            this.notifier.notify('error',result.message);
            // console.log("notifier notify err called")
            this.isDisableVocSave = false;
          }
          this.iService.vocScreenPng = []
        },(err) =>
        {
          this.notifier.notify('error','Something Went Wrong');
          console.log("notifier notify err11 called")
          //console.log(err,'erros');
        })
        this.iService.isvocadd = true;
        this.iService.isvocEdit = false;
        this.iService.vocIntroFormtitle = "";
        this.iService.vocIntroScreenName = "";
        this.iService.vocIntroFormSubtitle = [{value:""}];
        this.iService.copyvocIntroFormSubtitle = [];
        this.iService.copyvocIntroFormtitle = "";
        this.iService.start_time="";
        this.iService.end_time="";
        this.iService.comment="";
        this.markNewVocSwitch = true;
        this.isDisableVocSave = false;
        setTimeout(() => {
          this.cdr.detectChanges();  // Ensure Angular picks up the changes
        }, 100);
      }
    }
   
  }

  onVocAddFormSubmit = () => {
    // console.log("button clicked")
    if (this.isDisableVocSave) {
      this.notifier.notify('info','Voc Creation in Progress');
      return;
    }
    let temp = this.reportService.fileName.split('.')
    let fileType = temp[temp.length - 1];
    let data = {'startTime':this.iService.start_time,'endTime':this.iService.end_time,comment:this.iService.comment}
    if (fileType == 'mp4') {
      if (this.iService.vocIntroFormtitle && this.iService.vocIntroFormtitle != "") {
        if((this.Validation(data))){
          this.markNewVocSwitch = true;
          this.iService.isvocadd = true;
          this.isDisableVocSave = true;
          if (this.iService.isvocEditFormSubmit) {
            this.notifier.notify('info','Voc Edit in Progress');
          }else{
            this.notifier.notify('info','Voc Creation in Progress');
          }
          var introObj = {"comments":this.iService.comment,"title":"","list":[]}
          if(this.iService.vocIntroFormtitle)
            {
              introObj['title'] = this.iService.vocIntroFormtitle;          
            }
          if(this.iService.vocIntroFormSubtitle)
          {
            let arr = this.iService.vocIntroFormSubtitle.map((va:any) => va.value).filter(v => v);
            if(arr.length > 0)
            {
              introObj['list'] = arr;
            }
          }
          this.vocReff = document.getElementById('vocPNGID') as HTMLElement;
          this.renderer.setProperty(this.vocReff, 'innerHTML','');
          const voc = this.renderer.createElement('div');
          this.renderer.addClass(voc, 'table');
          const vocIntroFactory = this.fResolver.resolveComponentFactory(VocIntroPngComponent);
          const vocIntroRef = this.viewContainer.createComponent(vocIntroFactory);
          vocIntroRef.instance.introObj = introObj;    
          const vocScreen = vocIntroRef.location.nativeElement.firstChild;
          this.renderer.appendChild(voc, vocScreen);
          this.renderer.appendChild(this.vocReff, voc);
          vocIntroRef.instance.dataEmitter.subscribe(() => {
            let data = new FormData();
            data.append('image', this.iService.vocScreenPng[0], this.iService.vocScreenPng[0]['lastModified']+'.png');
            this.apiService.addVocIntroScreen(data).subscribe((result) =>
            {
              if(result.status === 'ok')
              {
                this.iService.vocIntroScreenName = result['file']
                this.onVocAddSubmit();
                // this.reportService.getVocList();
                // this.notifier.notify('info','Voc Creation in Progress');
                // this.markNewVocSwitch = true;
              }
              else
              {
                this.notifier.notify('error',result.message);
              }
              this.iService.vocScreenPng = []
            },(err) =>
            {
              this.notifier.notify('error','Something Went Wrong');
            })
            this.renderer.setProperty(this.vocReff, 'innerHTML','');
          });
        }
      }else{
        this.onVocAddSubmit()
      } 
    }else{
      this.isDisableVocSave = false;
      this.notifier.notify('error','VOC supports only mp4 files!');
    }   
  }

  


  // ConvertIndextoArray = () =>
  // {
  //   let z:number = this.vocdescTitle;
  //   let arr = [];
  //   for(let j=0;j<z;j++)
  //   {
  //     arr.push(j);
  //   }
  //   return arr;
  // }
  // addvocdesInc = (n:number) =>
  // {
  //   if(this.vocdescTitle < 5)
  //   {
  //     this.vocdescTitle += n;
  //   }
  // }
  openVocScreenIntroModal = (type:string,index?:number) => {
    let Width = '681px';
    // let Height = '450px';onVocAddFormSubmit()
    let Height = 'auto';
    // let Height = calc(100vh - 220px);
    this.Dialoge.open(VocIntroComponent, {
      width: Width,
      height: Height,
      data: {
        type:type,
        editIndex:index || index === 0?index:-1
      }
    })
  }
  openDeletePopUp = (data:any = {},type?:string) =>
  {
    let Width = '344px';
    let Height = '160px';
    this.Dialoge.open(DeletePopComponent, {
      width: Width,
      height: Height,
      data:{
        vocData:data,
        type:type ? type : ''
      }
    })

  }
  clubVocEdit(index: number) {
    let clubObj = this.iService.VOCClubList[index];
    let vocsArr = clubObj['voc_files'];
    this.iService.VOCsToBeClub = {};
    this.iService.VOCsToBeClub['title'] = clubObj['name'];
    this.iService.VOCsToBeClub['vocs'] = [];
    let dummyIndex = 1;
    vocsArr.forEach((voc) => {
      let entity_id = voc['entity_id'];
      if(voc['vcm_type'] == 'screen'){
        this.iService.VOCsToBeClub['vocs'].push(entity_id);
      }
      else{
        if(this.iService.vocType == 'study'){
          this.iService.vocStudyLevelArray.forEach((parentObj) => {
            parentObj['vocs'].forEach((mainVOC) => {
              if(mainVOC['uuid'] == entity_id){
                this.clubingVocArray.push({uuid:entity_id,index:dummyIndex})
                this.iService.VOCsToBeClub['vocs'].push(mainVOC);
                dummyIndex = dummyIndex+1;
              }
            })
          })
        }
      }
    })
    this.iService.isVocClubEdit = true;
    this.iService.isclubVoc = true;
    this.voc_club_show = true;
    this.editClubUUID = clubObj['uuid'];
  }

  VocEdit = (ind:number) =>
  {
    this.iService.isvocEditFormSubmit = true;
    this.markNewVocSwitch = false;
    if(!this.iService.VOCList[ind]['misc']['preview'])
    {
      this.iService.vocIntroFormtitle = "";
      this.iService.vocIntroFormSubtitle = [{value:""}];
      this.iService.isvocadd = true;
      this.iService.isvocEdit = false;
    }
    else
    {
      this.iService.vocIntroFormtitle = this.iService.VOCList[ind]['misc']['preview']['title'];
      this.iService.copyvocIntroFormtitle = this.iService.VOCList[ind]['misc']['preview']['title'];
      if(!this.iService.VOCList[ind]['misc']['preview']['text'])
      {
        this.iService.vocIntroFormSubtitle = [{value:""}]
        this.iService.copyvocIntroFormSubtitle = []
      }
      if(this.iService.VOCList[ind]['misc']['preview']['text'])
      {
        let arr = [];
        this.iService.VOCList[ind]['misc']['preview']['text'].forEach((va) => arr.push({value:va}));
        this.iService.vocIntroFormSubtitle = arr;
        this.iService.copyvocIntroFormSubtitle = this.iService.VOCList[ind]['misc']['preview']['text'];
      }
      this.iService.isvocadd = false;
      this.iService.isvocEdit = true;
    }
    this.iService.start_time = this.iService.VOCList[ind]['start_time'];
    this.iService.end_time = this.iService.VOCList[ind]['end_time'];
    this.iService.comment = this.iService.VOCList[ind]['misc']['comment'];
    // this.iService.current_file_uuid = this.iService.VOCList[ind]['uuid'];
    this.iService.current_voc_uuid = this.iService.VOCList[ind]['uuid'];
  }
  Vocdelete = (ind:number) =>
  {
    this.iService.isVocFileDelete = true;
    this.openDeletePopUp(this.iService.VOCList[ind],'voc');
  }
  VocdeleteFromStudy = (ind:number,ind1:number) =>
  {
    this.iService.isVocFileDelete = true;
    this.openDeletePopUp(this.iService.vocStudyLevelArray[ind1]['vocs'][ind],'voc');
  }
  clubVocdelete(ind:number) {
    this.iService.isVocFileDelete = true;
    this.openDeletePopUp(this.iService.VOCClubList[ind],'club');
  }
  EmailShowOrNot = () =>
  {
    // console.log(this.isEmailAllNotifyShow,"dsdsdsdds");
    this.isEmailAllNotifyShow = !this.isEmailAllNotifyShow;

  }
  CommentNotifyChange = (obj:any) =>
  {
    for(let item of this.iService.commentNotifEmailyArr)
    {
      if(item.value === obj)
      {
        item.checked = !item.checked;
      }
    }
  }
  ChangeVocState = (ind:number) =>
  {
    if(ind === 1)
    {
      this.voc_customer_show = true;
      this.voc_club_show = false;
    }
    else
    {
      this.voc_customer_show = false;
      this.voc_club_show = true;
    }
    if(this.iService.vocType == 'study') {
      this.reportService.getRepositoryDetail(this.iService.uuid);
    }
    this.iService.isVocClubEdit = false;
    this.iService.isclubVoc = false;
    this.iService.VOCsToBeClub = null;
    this.clubingVocArray = [];
    this.iService.isvocEdit = true;
    this.iService.isvocadd = false;
    this.markNewVocSwitch = true;
    this.editClubUUID = null;
  }
  VocCheckboxInput = (item:any) =>
  {
    let z = this.clubingVocArray.findIndex((va:{}) => va['uuid'] === item['uuid']);
    if(z === -1)
    {
      let obj = {'uuid':item['uuid'],'index':this.clubingVocArray.length+1}
      this.clubingVocArray.push(obj);
    }
    else{
      this.clubingVocArray.splice(z,1);
      this.clubingVocArray = this.clubingVocArray.map((va,ind) => ({'uuid':va['uuid'],'index':ind+1}));
    }
    // console.log(this.clubingVocArray,'kkkkkk');
  
  }
  GetIndexofVoc = (uuid:any) =>
  {
    let d = this.clubingVocArray.find(va => va.uuid === uuid);
    if(d)
    {
      return d.index;
    }
    return 0;
  }
  CancelClubVoc = () =>
  {
    this.clubingVocArray = [];
    this.iService.isclubVoc = false;
    this.iService.VOCsToBeClub = null;
  }
  CheckedClubVoc = (item:any) =>
  {
    let d = this.clubingVocArray.find((va) => va['uuid'] === item['uuid']);
    if(d)
    {
      return true;
    }
    return false;

  }
  clubVocClip = () =>
  {
    this.iService.isclubVoc = true;
    this.editClubUUID = null;
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.iService.VOCsToBeClub.vocs, event.previousIndex, event.currentIndex);
  }

  prevVocClub(){
    // this.iService.VOCsToBeClub = null;
    this.voc_club_show = false;
    this.voc_customer_show = true;
    this.iService.isVocClubEdit = false;
  }

  clubVOCs() {
    if(this.clubingVocArray.length>=2){
      if(this.iService.VOCsToBeClub){
        let copiedInstance = this.iService.VOCsToBeClub;
        this.iService.VOCsToBeClub = {};
        this.iService.VOCsToBeClub['title'] = copiedInstance['title'];
        this.addToVOCsToBeClub();
        copiedInstance['vocs'].forEach((scn) => {
          if(scn.type == 'screen') {
            this.iService.VOCsToBeClub['vocs'].push(scn);
          }
        })
      }
      else{
        this.iService.VOCsToBeClub = {};
        this.iService.VOCsToBeClub['title'] = 'Clubbed VOC 1';
        this.addToVOCsToBeClub();
      }
      this.iService.isVocClubEdit = true;
      this.voc_club_show = true;
      this.voc_customer_show = false;
    }
    else{
      this.notifier.notify('error','Please choose atleast two vocs to club');
    }
  }

  addToVOCsToBeClub() {
    this.iService.VOCsToBeClub['vocs'] = [];
    this.clubingVocArray.forEach((club:any) => {
      let voc;
      if(this.iService.vocType == 'file') {
        this.iService.VOCList.forEach((voc1) => {
          if(voc1.uuid == club.uuid) {
            voc = voc1
          }
        })
        this.iService.VOCsToBeClub['vocs'].push(voc);
      }
      else {
        this.iService.vocStudyLevelArray.forEach((vocsObj) => {
          vocsObj.vocs.forEach((voc1) => {
            if(voc1.uuid == club.uuid) {
              voc = voc1
            }
          })
        })
        this.iService.VOCsToBeClub['vocs'].push(voc);
      }
    });
    // console.log("VOCsToBeClub ===> ",this.iService.VOCsToBeClub);
  }

  clubNewVOCs() {
    this.iService.isclubVoc = true;
    this.voc_customer_show = true;
    this.voc_club_show = false;
    this.clubingVocArray = [];
    this.iService.isVocClubEdit = false;
    this.editClubUUID = null;
  }

  // saveVocClub(){
  //   if(this.iService.VOCsToBeClub && this.iService.VOCsToBeClub.vocs && this.iService.VOCsToBeClub.vocs.length>0){
  //     if(this.iService.VOCsToBeClub.title){
  //       let data = {};
  //       data['club_name'] = this.iService.VOCsToBeClub.title;
  //       data['details'] = [];
  //       this.iService.VOCsToBeClub.vocs.forEach((elem) => {
  //         if(elem.type == 'screen'){
  //           let newObj = {};
  //           newObj['type'] = 'screen';
  //           newObj['preview'] = elem['preview'];
  //           data['details'].push(newObj);
  //         }
  //         else{
  //           let clubObj = {};
  //           clubObj['type'] = 'voc';
  //           clubObj['uuid'] = elem.uuid;
  //           data['details'].push(clubObj);
  //         }
  //       }); 
  //       if(this.editClubUUID){
  //         data['uuid'] = this.editClubUUID;
  //         // this.editClubVoc(data);
  //         console.log("edit club data ===> ",data);
  //       }
  //       else{
  //         data['study_id'] = this.iService.uuid;
  //         console.log("add club data ===> ",data);
  //         // this.addClubVoc(data);
  //       }
  //     }
  //     else{
  //       this.notifier.notify('error','Please enter voc club title');
  //     }
  //   }

  // }

  saveVocClub(){
    if (this.isDisableVocClub) {
      this.notifier.notify('info','Processing VOC data, please try again');
      return;
    }
    if(this.iService.VOCsToBeClub && this.iService.VOCsToBeClub.vocs && this.iService.VOCsToBeClub.vocs.length>0){
      if(this.iService.VOCsToBeClub.title){
        this.isDisableVocClub = true;
        let data = {};
        var introObj = {"comments":this.iService.VOCsToBeClub.title,"title":"","list":[]}
        data['club_name'] = this.iService.VOCsToBeClub.title;
        data['details'] = [];
        // var vocScreen = this.iService.VOCsToBeClub.vocs.find((va) => va.type == 'screen');
        // if(vocScreen){
        //   let newObj = {};
        //     newObj['type'] = 'screen';
        //     newObj['preview'] = vocScreen['preview'];
        //     introObj['title'] = vocScreen['preview']['title'];
        //     introObj['list'] = vocScreen['preview']['text'];
        //     data['details'].push(newObj);
        // }
        this.iService.VOCsToBeClub.vocs.forEach((elem) => {
          if(elem.type == 'screen'){
            let newObj = {};
            newObj['type'] = 'screen';
            newObj['preview'] = elem['preview'];
            introObj['title'] = elem['preview']['title'];
            introObj['list'] = elem['preview']['text'];
            data['details'].push(newObj);
          }
          else{
            let clubObj = {};
            clubObj['type'] = 'voc';
            clubObj['uuid'] = elem.uuid;
            data['details'].push(clubObj);
          }
        }); 
        if(this.editClubUUID){
          data['uuid'] = this.editClubUUID;
          // console.log("edit club data ===> ",data);
          // console.log("introObj ===> ",introObj);
          if (introObj && introObj['title'] && introObj['title'] != '') {
            this.createClubbedVocIntroScreen(introObj,data,"edit");
          }else{
            this.editClubVoc(data);
          }
        }
        else{
          data['study_id'] = this.iService.uuid;
          // console.log("add club data ===> ",data);
          // console.log("introObj ===> ",introObj);
          if (introObj && introObj['title'] && introObj['title'] != '') {
            this.createClubbedVocIntroScreen(introObj,data,"create");
          }else{
            this.addClubVoc(data);
          }
        }
      }
      else{
        this.isDisableVocClub = false;
        this.notifier.notify('error','Please enter voc club title');
      }
    }

  }

  createClubbedVocIntroScreen(introObj:any,data:any,action:string) {
    this.voc_club_show = true;  // show voc club section
    this.voc_customer_show = false; // hode voc customer (list) section
    this.iService.isVocClubEdit = false;  // hide club edit section in voc club section
    this.isVocClubHasIntroScreen = true;  // show intro screen in voc club section

    if (action == 'create') {
      this.notifier.notify('info', 'VOC Club Creation in Progress');
    }else if (action == 'edit') {
      this.notifier.notify('info', 'VOC Club Edit in Progress');
    }

    this.vocReff = document.getElementById('vocPNGID') as HTMLElement;
    this.renderer.setProperty(this.vocReff, 'innerHTML','');
    const voc = this.renderer.createElement('div');
    this.renderer.addClass(voc, 'table');
    const vocIntroFactory = this.fResolver.resolveComponentFactory(VocIntroPngComponent);
    const vocIntroRef = this.viewContainer.createComponent(vocIntroFactory);
    vocIntroRef.instance.introObj = introObj;    
    const vocScreen = vocIntroRef.location.nativeElement.firstChild;
    this.renderer.appendChild(voc, vocScreen);
    this.renderer.appendChild(this.vocReff, voc);
    vocIntroRef.instance.dataEmitter.subscribe(() => {
      let body = new FormData();
      body.append('image', this.iService.vocScreenPng[0], this.iService.vocScreenPng[0]['lastModified']+'.png');
      // this.cdr.detectChanges();
      setTimeout(() => {
        this.apiService.addVocIntroScreen(body).subscribe((result) =>
        {
          // this.cdr.detectChanges();
          if(result.status === 'ok')
          {
            this.iService.vocIntroScreenName = result['file'];
            data.details.map((item) => {
              if(item.type == 'screen') {
                item.preview['image'] = this.iService.vocIntroScreenName;
              }
            })
            if (action == 'create') {
              this.addClubVoc(data);
            }else if (action == 'edit') {
              this.editClubVoc(data);
            }
          }
          else
          {
            this.notifier.notify('error',result.message);
          }
          this.iService.vocScreenPng = []
        },(err) =>
        {
          // this.cdr.detectChanges();
          this.notifier.notify('error','Something Went Wrong');
        })
      },0);
      this.renderer.setProperty(this.vocReff, 'innerHTML','');
    });
  }

  iSFileVocShow = (index1:number) =>
  {
    // console.log(index1,'Hiiiii');
    let d = this.fileVocListShow.findIndex((va) => va === index1);
    if(d == -1)
    {
      return 1
    }
    return 0;
    // this.fileVocListShow.push(index1);
  }
  FileVocPanelShow = (index1:number) =>
  {
    let d1 = this.fileVocListShow.findIndex((va) => va === index1);
    if(d1 == -1)
    {
      // console.log(index1,'if');
      this.fileVocListShow.push(index1);
      // console.log(this.fileVocListShow);

    }
    else
    {
      this.fileVocListShow.splice(d1,1);
      // console.log(this.fileVocListShow,'else');
    }
  }
  ChecVocPanelOpen = (index1:number) =>
  {
    let d = this.fileVocListShow.findIndex((va) => va === index1);
    return d != -1 ?1:0;
  }
  // getHeightClass(){
  //   if(this.iService.vocType=='study'){
  //     if(this.iService.isvocEditFormSubmit) return 'input_voc_scroll';
  //     return 'full_voc_scroll';
  //   }
  //   else{
  //     if(this.iService.isvocEditFormSubmit) return 'input_voc_scroll';
  //     return 'btn_voc_scroll'
  //   }
  // }

  clubScreenEdit(index: number) {
    this.openVocScreenIntroModal('club_voc_edit',index);
  }

  clubScreenDelete(index: number) {
    this.iService.VOCsToBeClub.vocs.splice(index,1);
  }
  ProcessingTestForSubstring = (val:number) =>
  {
    return +val === 1 ? 50 :10;
  }

  hambergerStudyClick(pIndex,mIndex,e) {
    e.stopPropagation();
    this.iService.vocStudyLevelArray[pIndex]['vocs'].forEach((voc,ind) => {
      if(ind == mIndex) {
        this.iService.vocStudyLevelArray[pIndex]['vocs'][ind]['isHambergerClicked'] = true;
      }
      else{
        this.iService.vocStudyLevelArray[pIndex]['vocs'][ind]['isHambergerClicked'] = false;
      }
    })
  }

  addClubVoc(data) {
    this.apiService.addClubVoc(data).subscribe((result) => {
      if (!this.isVocClubHasIntroScreen) {
        this.notifier.notify('info', 'VOC Club Creation in Progress');
      }
      this.isVocClubHasIntroScreen = false;
      this.isDisableVocClub = false;
      this.cdr.detectChanges();
      this.fetchClubbedData(result);
    })
  }
  
  editClubVoc(data) {
    this.apiService.editClubVoc(data).subscribe((result) => {
      if (!this.isVocClubHasIntroScreen) {
        this.notifier.notify('info', 'VOC Club Edit in Progress');
      }
      this.isVocClubHasIntroScreen = false;
      this.isDisableVocClub = false;
      this.cdr.detectChanges();
      this.fetchClubbedData(result);
    })
  }

  selectClubTitle(clubTitleInput: HTMLInputElement) {
    clubTitleInput.focus()
  }

  fetchClubbedData(result) {
    if(result['status'] == '1'){
      this.editClubUUID = null;
      this.iService.isVocClubEdit = false;
      this.iService.isclubVoc = false;
      this.iService.VOCsToBeClub = null;
      this.clubingVocArray = [];
      if(this.iService.vocType == 'study') {
        this.voc_club_show = true;
        this.voc_customer_show = false;
        this.reportService.getRepositoryDetail(this.iService.uuid);
      }
      else{
        this.voc_club_show = false;
        this.voc_customer_show = true;
      }
    }
    else{
      this.notifier.notify('error','Something went wrong VOCs could not be clubbed');
    }
  }
  vocProcessandFailedStatus(item){
    if(item.status === 0)
    {
    //  let arr = item.modified.split(',')[1];
    //  let time = arr.split(' ');
    //  let voc_time = time[1].split(":");
    //  let voc_current_time = (+voc_time[0]%12)*3600 + +voc_time[1]*60;
    //  let time_diff = this.RealcurrenTime - voc_current_time;
    //  if(time_diff > 600)
    //  {
    //   return 2;
    //  }
      return 1;
    }
    return 0;
  }
}
